// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ClientEndpointMS2Version {
	V1_0 = 0,
	V1_1 = 1,
	V1_2 = 2,
	V1_3 = 3,
	V1_4 = 4,
	V1_5 = 5,
	V1_8 = 6,
	V1_9 = 7,
}

export const ClientEndpointMS2VersionDisplayNames: { [key in keyof typeof ClientEndpointMS2Version]?: string} = {
	"V1_0": "1.0",
	0 : "1.0",
	"V1_1": "1.1",
	1 : "1.1",
	"V1_2": "1.2",
	2 : "1.2",
	"V1_3": "1.3",
	3 : "1.3",
	"V1_4": "1.4",
	4 : "1.4",
	"V1_5": "1.5",
	5 : "1.5",
	"V1_8": "1.8",
	6 : "1.8",
	"V1_9": "1.9",
	7 : "1.9",
}

export const getClientEndpointMS2VersionDisplayName = (key: ClientEndpointMS2Version | (keyof typeof ClientEndpointMS2Version & string)) => {
	return ClientEndpointMS2VersionDisplayNames[key];
}

